import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/release-notes.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/release-notes')({
  component: Content,
});
